import RadioButtonItem from "@/Modules/ModularConfigurator/options/radioOption/RadioButtonItem";
import {
   Item,
   SelectedItems
} from "@/types/productTypes";
import { ControlHover } from "../MainEditorPanel";

type ItemVisualizerProps = {
   stageId: number;
   optionId: number;
   item: Item | null;
   index: number;
   controlValue: SelectedItems;
   radio: any;
   controlHovered: ControlHover | null;
   setControlHovered: React.Dispatch<React.SetStateAction<ControlHover | null>>;
};

export default function ItemVisualizer({
   stageId,
   optionId,
   item,
   index,
   controlValue,
   radio,
   setControlHovered,
}: ItemVisualizerProps) {
   if (!item) return null;

   const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>) => {
      if (!item.id) return;
      if (e.ctrlKey) {
         setControlHovered({
            type: "Item",
            stageId,
            optionId,
            itemId: item.id,
         });
      }
   };

   const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
      if (!item.id) return;
      e.stopPropagation();
      if (e.ctrlKey) {
         setControlHovered({
            type: "Item",
            stageId,
            optionId,
            itemId: item.id,
         });
      } else {
         setControlHovered(null);
      }
   };

   const handleMouseLeave = () => {
      setControlHovered(null);
   };

   return (
      <div
         onMouseEnter={handleMouseEnter}
         onMouseMove={handleMouseMove}
         onMouseLeave={handleMouseLeave}
         className="flex flex-row w-full justify-center items-center h-full"
      >
         <div className="w-full flex">
            <RadioButtonItem
               key={index}
               item={item}
               index={index}
               controlValue={controlValue}
               radio={radio}
            />
         </div>
      </div>
   );
}
